import React from 'react'
import styles from './ViewFinder.module.css'
import {
  IconRadiusTopLeft,
  IconRadiusTopRight,
  IconRadiusBottomLeft,
  IconRadiusBottomRight
} from '@tabler/icons-react'

const ViewFinder = () => {
  return (
    <>
      <div className={styles.viewFinder}>

        <IconRadiusTopLeft size={75} className={styles.radiusTopLeftIcon}/>
        <IconRadiusTopRight size={75} className={styles.radiusTopRightIcon}/>
        <IconRadiusBottomLeft size={75} className={styles.radiusBottomLeftIcon}/>
        <IconRadiusBottomRight size={75} className={styles.radiusBottomRightIcon}/>

      </div>
    </>
  )
}

export default ViewFinder
